module.exports = __webpack_public_path__ + "static/media/RKBrowser5w721@1x.53e14b90.jpg";